export const RECEIVABLES_TABLE_ARIA_LABEL = 'Дебіторська заборгованість';
export const RECEIVABLES_TABLE_MIN_WIDTH = 1380;
export const RECEIVABLES_DATE_COLUMN_INDEXES = [5, 6] as const;
export const RECEIVABLES_TABLE_HEADERS = [
  'Найменування контрагента',
  'ЄДРПОУ',
  'Предмет заборгованості',
  'Загальна заборгованість, тис. од.',
  'Прострочена заборгованість, тис. од.',
  'Дата виникнення',
  'Дата погашення',
] as const;
export const RECEIVABLES_TABLE_COLUMN_WIDTHS = [
  '20%',
  '10%',
  '20%',
  '16%',
  '16%',
  '9%',
  '9%',
] as const;
